import React from "react";
import Col from "../../../UIcomponent/Column";
import "./TeacherResume.scss";
import { CardTitleAction } from "../../../Component/CardTitleAction/CardTitleAction";
import TeacherResumeDic from "./TeacherResumeDic";
import { Divider } from "antd";
const TeacherResume = (props) => {
  const { Resume, lang } = props;
  let teacher = props.teacher || {};
  let loading = Resume !== null ? false : true;
  let borderShow =
    loading === false
      ? Object.keys(Resume).map((key) =>
          Resume[key].length > 0 ? true : false
        )
      : [false, false, false];
  return (
    // Resume !== null &&
    <Col className="l__TeacherResume" xl={24} lg={24} md={24} sm={24} xs={24}>
      <Col
        xl={22}
        lg={22}
        md={22}
        sm={22}
        xs={22}
        className="l__TeacherResume__Title"
      ></Col>
      <Col
        xl={22}
        lg={22}
        md={22}
        sm={22}
        xs={22}
        className="l__TeacherResume__Detail"
        style={{
          ...props.style,
        }}
      >
        <Col
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          className="c__TeacherResume__Item"
          style={
            {
              // display: borderShow[0] === false && "none",
            }
          }
        >
          {Resume && Resume.experience.length > 0 && (
            <>
              <Col
                xl={24}
                lg={24}
                md={24}
                sm={24}
                xs={24}
                className="c__TeacherResume__Item__Title"
                loading={loading}
              >
                {Resume && (
                  <Col
                    style={{
                      color: "#333333",
                      fontSize: "20px",
                    }}
                  >
                    <span></span>
                    <h2 style={{ all: "unset" }}>
                      {`${TeacherResumeDic.experience[`${lang}`]} ${
                        teacher.FirstName
                          ? teacher.FirstName + " " + teacher.LastName
                          : ""
                      }`}
                    </h2>
                    {/* Experience */}
                  </Col>
                )}
              </Col>
              {Resume.experience.map((exp, index) => {
                return (
                  <Col
                    className="o__TeacherResume__Item"
                    xl={24}
                    lg={24}
                    md={24}
                    sm={24}
                    key={index}
                    xs={24}
                    lang={lang}
                    loading={loading}
                  >
                    <Col
                      xl={24}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      className="o__TeacherResume__Item__Title"
                    >
                      <Col className="_resume_item_title">{exp.title}</Col>
                      <Col className="_resume_item_description">{`${exp.company}`}</Col>
                      <Col
                        xl={24}
                        lg={24}
                        md={24}
                        sm={24}
                        xs={24}
                        className="_resume_item_description"
                      >
                        {exp.description}
                      </Col>
                    </Col>
                    <Col
                      xl={24}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      className="o__TeacherResume__Item__Location"
                      lang={lang}
                    >
                      {exp.city + " " + exp.country}
                    </Col>
                    {/* <Col
                                        xl={24} lg={24} md={24} sm={24} xs={24}
                                        className='o__TeacherResume__Item__FromTo'
                                    >
                                        {DateTime.getFullYear(exp.from) + ' - ' + DateTime.getFullYear(exp.to)}
                                    </Col> */}
                    {Resume.experience.length != index + 1 && (
                      <div className="custom_divider" />
                    )}
                  </Col>
                );
              })}
            </>
          )}
          <div className="custom_divider full" />
        </Col>
        <Col
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          className="c__TeacherResume__Item"
          loading={loading}
          style={
            {
              // display: borderShow[1] === false && "none",
            }
          }
        >
          {Resume && Resume.education.length > 0 && (
            <>
              <Col
                xl={24}
                lg={24}
                md={24}
                sm={24}
                xs={24}
                className="c__TeacherResume__Item__Title"
              >
                {Resume && (
                  <Col
                    className="_resume_item_description"
                    style={{ fontSize: "20px" }}
                  >
                    <span></span>
                    {TeacherResumeDic.education[`${lang}`]}
                    {/* Education */}
                  </Col>
                )}
              </Col>
              {Resume &&
                Resume.education.map((edu, index) => {
                  return (
                    <Col key={index} xl={24} className="o__TeacherResume__Item">
                      {/* <Col
                                    xl={24} lg={24} md={24} sm={24} xs={24}
                                    className='o__TeacherResume__Item__FromTo'
                                >
                                    {PublicDic.from[`${lang}`] + ' ' + DateTime.getFullYear(edu.from) + ' ' + PublicDic.to[`${lang}`] + ' ' + DateTime.getFullYear(edu.to)}
                                </Col> */}
                      <Col
                        // xl={24} lg={24} md={24} sm={24} xs={24}
                        className="_resume_item_title"
                      >
                        {edu.field}
                        {/* <span
                                        style={{
                                            margin: '0px 5px 0px 5px'
                                        }}
                                    >{`(${edu.field})`}</span> */}
                      </Col>
                      <Col
                        xl={24}
                        lg={24}
                        md={24}
                        sm={24}
                        xs={24}
                        className="_resume_item_description"
                        lang={lang}
                      >
                        {edu.academy}
                      </Col>
                      {Resume.education.length != index + 1 && (
                        <div className="custom_divider" />
                      )}
                    </Col>
                  );
                })}
            </>
          )}
          <div className="custom_divider full" />
        </Col>
        <Col
          xl={24}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          className="c__TeacherResume__Item"
          style={{
            // display: borderShow[2] === false && "none",
            border: "none",
          }}
          loading={loading}
        >
          {Resume && Resume.certificate.length > 0 && (
            <>
              <Col
                xl={24}
                lg={24}
                md={24}
                sm={24}
                xs={24}
                className="c__TeacherResume__Item__Title"
                style={{ fontSize: "20px" }}
              >
                {Resume && (
                  <>
                    <span></span>
                    {TeacherResumeDic.certificate[`${lang}`]}
                    {/* Certificate */}
                  </>
                )}
              </Col>

              {Resume.certificate.map((cer, index) => {
                return (
                  <Col xl={24} className="o__TeacherResume__Item">
                    <Col
                      xl={24}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      className="o__TeacherResume__Item__Title"
                      style={{
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        margin: "7px 5px 7px 5px",
                        fontSize: "16px",
                        color: "#333333",
                      }}
                    >
                      {cer.title}
                    </Col>
                    {Resume.certificate.length != index + 1 && (
                      <div className="custom_divider" />
                    )}
                  </Col>
                );
              })}
            </>
          )}
        </Col>
      </Col>
    </Col>
  );
};
export default TeacherResume;
